import React from "react";
import Ad from "components/Library/Ad";
import styles from "./StreamCapAd.css";
import PropTypes from "prop-types";

import { Waypoint } from "react-waypoint";
import { streamCapAdInViewDataLayerEvent } from "utils/analytics";

const StreamCapAd = ({ adUnit, kwAfter }) => {
  return (
    <Waypoint onEnter={() => streamCapAdInViewDataLayerEvent()}>
      <div className={styles.wrapper}>
        <Ad
          adUnit={adUnit}
          slotSize="fluid"
          renderWhenViewable={false}
          collapseEmptyDiv={true}
          targeting={{ "kw-after": kwAfter, pos: "mid0" }}
        />
      </div>
    </Waypoint>
  );
};

StreamCapAd.propTypes = {
  adUnit: PropTypes.string,
  kwAfter: PropTypes.string,
};

StreamCapAd.defaultProps = {
  adUnit: "axios",
  kwAfter: "",
};

export default StreamCapAd;
